module.exports = __webpack_public_path__ + "static/media/cm_logo_wh.176d58f9.svg";